import { createSelector } from 'redux-bundler';

export const reactErrorNotification = createSelector(
  'selectErrorsToShow',
  'selectErrors',
  'selectErrorsShown',
  'selectIsLoggedIn',
  (errorsToShow, errorsLookup, shown, loggedIn) => {
    // list of keys from error store
    if (!errorsToShow.length || shown || !loggedIn) return null;

    return {
      actionCreator: 'doSetErrorsAsShown',
      args: [{ errorsLookup, errorsToShow }],
    };
  },
);
